import {Component, OnInit} from '@angular/core';
import {Product} from '../../models/Product';
import {ActivatedRoute, Params} from '@angular/router';

import 'rxjs/add/operator/switchMap';
import {ProductService} from '../../shared/product.service';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'ciu-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.css']
})
export class ProductDetailsComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private productService: ProductService
  ) { }
 
  product: Product;

  ngOnInit() {
    this.loadLocation();
    this.route.params
      .switchMap((params: Params) => {
        return this.productService.getProductById(params['id']);
      })
      .subscribe((product: Product) => {
        this.product = product;
      });
  }

  location: string;

  loadLocation() {

    // this.http.get('')
    //   .subscribe(location => this.location = location);
  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/product-details/product-details.component.ts